import { logger } from "@/lib/utils/logger/logger";

export const uploadFiles = async (
  url: string,
  frontImage: File,
  backImage: File = undefined,
): Promise<Response> => {
  logger.info(`uploading files to ${url}`);

  const body = new FormData();
  body.append("frontImage", frontImage);
  if (backImage) {
    body.append("backImage", backImage);
  }

  return fetch(url, {
    method: "POST",
    body,
  });
};

export const base64ToFile = (
  rawBase64: string,
  filename: string,
  mimeType = "image/jpeg",
): File => {
  const byteString = atob(rawBase64);
  const byteArray = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new File([byteArray], filename, { type: mimeType });
};

// The device has a coarse pointer (touch scren) and the screen is narrow (≤ 768px)
export function isMobileDevice(): boolean {
  if (typeof window === "undefined") return false;

  return window.matchMedia("(pointer: coarse)").matches && window.innerWidth <= 768;
}
